import {
  SEND_BATCH_MAIL,
  BATCH_MAIL_LIST,

  EMAIL_BATCH_SUCCESS,
  EMAIL_BATCH_ERROR,
} from "./actionTypes"

const initialState = {
  successMsg: null,
  error: null,
}

const EmailBatch = (state = initialState, action) => {
  switch (action.type) {

    // add mail batch
    case SEND_BATCH_MAIL:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // list mail batch
    case BATCH_MAIL_LIST:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    case EMAIL_BATCH_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
      }
      break

    case EMAIL_BATCH_ERROR:
      state = { ...state, error: action.payload, loading: false, }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default EmailBatch
